module.exports = __webpack_public_path__ + "band_15.c335e47e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_15.png
// module id = cfb7
// module chunks = 0